export default __webpack_public_path__ + "static/media/ctg-2a.7a859952.webp";